import { useTheme } from '@/theme/ThemeProvider';
import { Button } from '@/components/ui/Button';
import type { ThemeMode } from '@guanwei/shared';

const OPTIONS: { value: ThemeMode; label: string; icon: string }[] = [
  { value: 'light', label: '日间', icon: '☀' },
  { value: 'dark', label: '夜间', icon: '☾' },
  { value: 'system', label: '跟随系统', icon: '◐' },
];

export function ThemeSwitcher() {
  const { mode, setMode } = useTheme();
  return (
    <div className="inline-flex items-center gap-1 p-1 rounded-pill bg-bg-2 border border-border">
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => setMode(opt.value)}
          aria-pressed={mode === opt.value}
          className={
            'inline-flex items-center gap-1 h-8 px-3 rounded-pill text-sm transition-colors duration-base ease-standard ' +
            (mode === opt.value
              ? 'bg-accent text-accent-fg shadow-sm'
              : 'text-fg-1 hover:text-fg')
          }
          title={opt.label}
        >
          <span aria-hidden>{opt.icon}</span>
          <span className="hidden sm:inline">{opt.label}</span>
        </button>
      ))}
    </div>
  );
}

/**
 * 简易切换按钮 —— 给页眉等紧凑场景用
 */
export function ThemeToggleButton() {
  const { resolved, toggle } = useTheme();
  return (
    <Button variant="ghost" size="sm" onClick={toggle} aria-label="切换主题">
      {resolved === 'dark' ? '☀' : '☾'}
    </Button>
  );
}
